import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { notifyUser } from "../services/helpers";
import UserContext from "../store/user-context";
import { downloadFile } from "../services/Base/base-service";

import secureLocalStorage from "react-secure-storage";
import { Link } from "react-router-dom";
import DownloadTypeEnum from "../helpers/Enums/DownloadTypeEnum";
import { Icon } from "design-react-kit";

const ProgressBar = ({ result, setError, type, fileToDownload }) => {
  const [progress, setProgress] = useState(0);
  const [fileBeingDownloaded, setFileBeingDownloaded] = useState(null);

  const userContext = useContext(UserContext);
  const navigate = useNavigate();

  let fileName = null;

  switch (type) {
    case DownloadTypeEnum.ExternalFlowZip:
      fileName = "zipFileName";
      break;
    case DownloadTypeEnum.ExternalFlowZipWithSign:
      fileName = "zipWithSignatureFileName";
      break;
    default:
      break;
  }

  useEffect(() => {
    if (
      type !== DownloadTypeEnum.ExternalFlowZipForSign &&
      fileToDownload !== null &&
      fileToDownload === result[fileName]
    ) {
      downloadZip();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result, fileToDownload]);

  const downloadZip = async () => {
    if (type === DownloadTypeEnum.ExternalFlowZipForSign) {
      setFileBeingDownloaded("zipForSign");
    } else {
      setFileBeingDownloaded(result[fileName]);
    }
    setError(null);
    setProgress(0);
    if (
      userContext.selectedClientFiscalCode !== null &&
      userContext.selectedClientName !== null
    ) {
      downloadFile(
        {
          downloadType: type,
          flowId: result.id,
        },
        navigate
      ).then(async (response) => {
        if (response.errors === undefined) {
          const fileName = secureLocalStorage.getItem("fileName");
          if (!response.body) return;
          const contentLength = response.headers.get("Content-Length");
          const totalLength =
            typeof contentLength === "string" && parseInt(contentLength);
          const reader = response.body.getReader();
          const chunks = [];
          let receivedLength = 0;
          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              notifyUser(
                `Scarica file ${fileName} completato`,
                "success",
                "it-check"
              );
              setFileBeingDownloaded(null);
              break;
            }
            chunks.push(value);
            receivedLength += value.length;
            if (typeof totalLength === "number") {
              const step = parseInt(
                parseFloat((receivedLength / totalLength).toFixed(2)) * 100
              );
              setProgress(step);
            }
          }
          const blob = new Blob(chunks);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          //});
        } else {
          setError(response.errors);
        }
      });
    }
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        {type !== DownloadTypeEnum.ExternalFlowZipForSign &&
          fileBeingDownloaded !== null &&
          fileBeingDownloaded === result[fileName] && (
            <div
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ "--value": progress }}
            ></div>
          )}
        {type !== DownloadTypeEnum.ExternalFlowZipForSign &&
          fileBeingDownloaded !== result[fileName] && (
            <Link
              to={null}
              className="downloadFile"
              onClick={(e) => downloadZip()}
            >
              {result[fileName]}
            </Link>
          )}
      </div>
      <>
        {type === DownloadTypeEnum.ExternalFlowZipForSign &&
          fileBeingDownloaded !== null &&
          fileBeingDownloaded === "zipForSign" && (
            <div
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ "--value": progress }}
            ></div>
          )}
        {type === DownloadTypeEnum.ExternalFlowZipForSign &&
          fileBeingDownloaded === null && (
            <div className="d-flex align-items-center ml-3">
              <Icon icon="it-download" fill="#06c" />
              <Link
                to={null}
                className="downloadZipForSigning"
                onClick={(e) =>
                  downloadZip(
                    DownloadTypeEnum.ExternalFlowZipForSign,
                    result.id
                  )
                }
              >
                Scarica PDF da firmare
              </Link>
            </div>
          )}
      </>
    </>
  );
};

export default ProgressBar;
